<template>
    <div class="chart-container">
        <canvas  ref="canvas"></canvas>
    </div>
</template>
<script>
//import Chart from 'chart.js'

export default {
    props: ['config'],
    data() {
        return {
            chart: null,
            Config: null
        }
    },
    mounted() {        
        this.$nextTick(() => {

            this.initChart()
            
        })

    },
    updated() {        
        this.$nextTick(() => {
            this.initChart()
        })
    },
    methods: {
        async initChart() {
            if (!this.$refs.canvas) {
                return;
            }
            let ctx = this.$refs.canvas.getContext('2d');
            if (this.chart) {
                this.chart.destroy();
            }
            this.Config.options = {
                ...this.Config.options,
                maintainAspectRatio: false,
                
            }

            const Chart = await import('chart.js').then(e => e.Chart)
            this.chart = new Chart(ctx,this.Config);
            

        }
    },
    watch: {
        config: {
            immediate: true,
            handler(value) {                
                this.Config = value;
                this.initChart();
            }
        }
    }
}
</script>
<style lang="less" scoped>
    .chart-container {
        position: relative;
        
        width: 100%;
        height: auto;
        min-height: 300px;
        max-height: 50vh;
    }
    div:fullscreen {
        .chart-container {
            height: 100%;
            max-height: ~"calc(100vh - 300px)";
            
        }
    }
</style>